import axiosInstance from '../../axiosInstance';

import { ISoulMatrixData } from './types';

export const getSoulMatrixData = async (token: string): Promise<ISoulMatrixData> => {
  const response = await axiosInstance.get<ISoulMatrixData>('/soul-matrix/my?language_code=ru', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
